<button *ngIf="user$ | async; let user" mat-stroked-button [routerLink]="['/store']">⚡ {{user.toVolts}}</button>